import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import VueRecaptcha from 'vue-recaptcha';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import RenewPassword from '@/plugins/graphql/mutations/v2/auth/reset-email.gql';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import { required, sameAs, minLength } from 'vuelidate/lib/validators';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import AesMixin from '@/helpers/vue_mixins/v2/AesMixin';
import RecaptchaMixin from '@/helpers/mixins/RecaptchaMixin';
import { PASSWORD_REGEXP } from '../helpers/constants/app';
// TODO: find a way to prevent octal literal expression in joining
// validation of 3 consecutive chars
const invalidValue = (value) => PASSWORD_REGEXP.test(value) && !/(.)\1\1/.test(value);
let ResetPassword = class ResetPassword extends Mixins(ViewportSizeMixin, FormValidationsMixin, FormMixin, RecaptchaMixin, AesMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            password: null,
            confirmPassword: null,
        };
    }
    get passwordCriteria() {
        return [
            `Alphanumeric and at least 8 characters with one special character.`,
            `The password cannot have more than two consecutive identical character (example: 111).`,
            `The password is case-sensitive.`,
            `The characters ' " & and spaces are not allowed.`,
            `The password cannot be the same as your merchant
       login name and should not contain any part of your company name or username.`,
        ];
    }
    async resetPassword() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.requestOnFlight();
            const token = this.$route.params.resetPasswordToken;
            return this.$apollo
                .mutate({
                mutation: RenewPassword,
                variables: {
                    input: {
                        resetPasswordToken: this.encrypt(token),
                        newPassword: this.encrypt(this.form.password),
                    },
                },
            })
                .then((result) => {
                const data = result.data.passwordResetEmail;
                this.successNotification(data.message);
                this.$router.push('/login/client');
                this.requestDone();
            })
                .catch((e) => {
                this.errorNotification(e.message);
                this.requestDone();
            });
        }
    }
};
ResetPassword = __decorate([
    Component({
        components: {
            VueRecaptcha,
            ActionButton,
            BaseTextField,
            FormHeader,
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$store.state.displayHomeNav = false;
                return true;
            });
        },
        validations: {
            form: {
                password: {
                    required,
                    minLength: minLength(8),
                    invalidValue,
                },
                confirmPassword: {
                    required,
                    sameAsPassword: sameAs('password'),
                },
            },
        },
    })
], ResetPassword);
export default ResetPassword;
